import React from "react";
import {
  FormControl as MuiFormControl,
  FormControlProps,
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps,
  FormHelperText as MuiFormHelperText,
  Switch as MuiSwitch,
} from "@mui/material";

export interface SwitchProps {
  /** Text to display with the switch. */
  label?: React.ReactNode;
  /** Helper text for hint or error messages. */
  helperText?: React.ReactNode;
  /** Switch state. */
  checked?: boolean;
  /** Function: the 'checked' state is provided as the first argument. */
  onChange: (arg0: boolean) => any;
  /** Props passed to the FormControlLabel */
  FormControlLabelProps?: Omit<FormControlLabelProps, "control" | "label" | "onChange" | "checked">;
}

// Temporary export for storybook documentation
export const SwitchForProps = (props: SwitchProps) => {};

// omit 'css' prop to avoid Typescript error making it required
const Switch = (props: SwitchProps & Omit<FormControlProps, "onChange" | "css">) => {
  const { checked, onChange, label, helperText, FormControlLabelProps, ...formControlProps } = props;
  const handleChange = (event: any, newChecked: boolean) => {
    onChange(newChecked);
  };
  return (
    <MuiFormControl {...formControlProps}>
      <MuiFormControlLabel
        checked={checked}
        control={<MuiSwitch color="primary" />}
        onChange={handleChange}
        label={label}
        {...FormControlLabelProps}
      />
      {helperText && <MuiFormHelperText>{helperText}</MuiFormHelperText>}
    </MuiFormControl>
  );
};

export default Switch;
